import { Global } from '@emotion/react';
import fontFamily from '../../styles/theme/fontFamily';

const Fonts = () => (
    <Global
        styles={ { fontFamily } }
    />
);
export default Fonts;
